import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormArrayTable = () => (
  <ComponentDocs
    name="<Form.ArrayTable/>"
    entry="ArrayTable"
    propsEntry="ArrayTableProps"
    namespace="FormCollections"
  >
    <ComponentExample
      name="Array table"
      import={import("examples/Forms/FormArrayTable/ArrayTableExample")}
      rawImport={import("examples/Forms/FormArrayTable/ArrayTableExample?raw")}
    />
    <ComponentExample
      name="Expanded rows"
      import={import(
        "examples/Forms/FormArrayTable/ArrayTableExpandedRowsExample"
      )}
      rawImport={import(
        "examples/Forms/FormArrayTable/ArrayTableExpandedRowsExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormArrayTable;
